var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.063 61.035C162.246 36.4537 140.783 18 115 18C94.5292 18 76.75 29.685 67.8958 46.785C46.575 49.065 30 67.2338 30 89.25C30 112.834 49.0542 132 72.5 132H164.583C184.133 132 200 116.04 200 96.375C200 77.565 185.479 62.3175 167.063 61.035Z",
    fill: "#48484A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.062 79.035C131.246 54.4537 109.783 36 84 36C63.5292 36 45.75 47.685 36.8958 64.785C15.575 67.065 -1 85.2337 -1 107.25C-1 130.834 18.0542 150 41.5 150H133.583C153.133 150 169 134.04 169 114.375C169 95.565 154.479 80.3175 136.062 79.035Z",
    fill: "#F2F2F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8877 187.321L54.912 186.881L61.9677 159.491L48.0527 157.951C45.7468 157.696 45.9273 156.428 46.8323 155.16C47.7373 153.892 47.0663 154.864 47.1634 154.714C53.2953 146.217 62.5042 133.553 74.7592 116.638L78.7349 117.078L71.6792 144.468L85.5942 146.008C87.5423 146.224 87.6754 147.567 87.2384 148.243L86.8941 148.808C68.1981 174.468 58.8877 187.321 58.8877 187.321Z",
    fill: "#DC7555"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.3ba73974ce3cbd6ba4c893321c324b57.svg";
export { ForwardRef as ReactComponent };